
export const validater = (type) => {
  switch (type) {
    case "phone":
      return /^09\d{8}$/;
    // case "email":  //另外單獨檢核
      // return /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
      // return /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
    case "code":
      return /^\d$/;
    //202208 Vulnerability Project Modify -- begin   
    case "verification_code": 
      return /^\d$/;
    //202208 Vulnerability Project Modify -- end   
    default:
      return;
  }
};


export const validateEmail = (data)=> {
  const regexList = [
    // Regex 1: 有引號(參考BH)
    /^"(?:.+?)"@((\[(\d{1,3}\.){3}\d{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}))$/,
    // Regex 2: 常見格式
    /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@((\[(\d{1,3}\.){3}\d{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/,
    // Regex 3: 支援 IP 和 domain (參考BH)
    /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/,
    // Regex 4: 限定 TLD(參考BH)
    /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[\w-]+\.(com|net|org|edu|mil|tv|biz|info)$/,
    // Regex 5: 支援 IP 或多層 domain)
    /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@((([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])){1}|([a-zA-Z0-9]+[\w-]+\.)+[a-zA-Z]{1}[a-zA-Z0-9-]{1,23})$/,
    // Regex 6: RFC 5322 接近格式 (參考BH)
    /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/
  ];

  for (let i = 0; i < regexList.length; i++) {
    if (regexList[i].test(data)) {
      //console.log(`Email is valid. Matched regex: ${i + 1}`);
      return true;
    }
  }
  return false;
};

export const validateData = (data, type) => {
  if(type === "email")
    return validateEmail(data);
  else
    return data.match(validater(type));

};	